import { MutationFunction } from '@tanstack/react-query';

import { get, patch } from '..';
import { buildUrl } from '../../utils';
import { ConfigType, IConfig, IConfigPayload } from '../../interfaces/customer';

export const getConfigs = (domainId?: string) =>
  get<ConfigType[]>(buildUrl(`/v1/customer/domain/${domainId}/configs`));

export const editConfigs: MutationFunction<IConfigPayload[], IConfig> = (
  variables,
) =>
  patch(
    buildUrl(`/v1/customer/domain/${variables.domainId}/configs`),
    variables.payload,
  );
